import React from 'react';
import { X } from 'lucide-react';
import toast from 'react-hot-toast';
import { MESSAGE_GOALS } from '../../../api/messages';

const MessageModal = ({
    isOpen,
    hasFull,
    profile,
    messageGoal,
    setMessageGoal,
    messageBody,
    setMessageBody,
    onClose,
    sendMessage,
    profileId
}) => {
    if (!isOpen || !hasFull) return null;

    return (
        <div className="fixed inset-0 z-[9999] bg-black/40 flex items-center justify-center p-4">
            <div className="w-full max-w-lg rounded-2xl bg-white border border-secondary-200 shadow-soft">
                <div className="px-5 py-4 border-b border-secondary-200 flex items-center justify-between">
                    <div className="min-w-0">
                        <div className="text-sm text-secondary-500">Сообщение пользователю</div>
                        <div className="text-lg font-semibold text-secondary-900 truncate">@{profile.username}</div>
                    </div>
                    <button type="button" className="p-2 rounded-lg hover:bg-secondary-50" onClick={onClose} title="Закрыть">
                        <X className="w-5 h-5 text-secondary-600" />
                    </button>
                </div>

                <div className="p-5 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-secondary-700 mb-1">Цель</label>
                        <select className="input w-full" value={messageGoal} onChange={(e) => setMessageGoal(e.target.value)}>
                            {MESSAGE_GOALS.map((g) => (
                                <option key={g} value={g}>{g}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-secondary-700 mb-1">Сообщение</label>
                        <textarea
                            className="input w-full h-28 resize-none"
                            value={messageBody}
                            onChange={(e) => setMessageBody(e.target.value)}
                            placeholder="Напишите сообщение…"
                            maxLength={2000}
                        />
                        <div className="mt-1 text-xs text-secondary-500">{messageBody.length} / 2000</div>
                    </div>
                </div>

                <div className="px-5 py-4 border-t border-secondary-200 flex items-center justify-end gap-2">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Отмена
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        disabled={sendMessage.isLoading || !messageBody.trim()}
                        onClick={async () => {
                            try {
                                await sendMessage.mutateAsync({
                                    toUserId: profileId,
                                    goal: messageGoal,
                                    body: messageBody.trim()
                                });
                                toast.success('Сообщение отправлено');
                                onClose();
                            } catch (e) {
                                const msg = e?.response?.data?.error?.message || e?.response?.data?.error || 'Ошибка отправки сообщения';
                                toast.error(msg);
                            }
                        }}
                    >
                        {sendMessage.isLoading ? 'Отправка…' : 'Отправить'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MessageModal;
